import { render, staticRenderFns } from "./usermag.vue?vue&type=template&id=24641f08&scoped=true&"
import script from "./usermag.vue?vue&type=script&lang=js&"
export * from "./usermag.vue?vue&type=script&lang=js&"
import style0 from "./usermag.vue?vue&type=style&index=0&id=24641f08&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24641f08",
  null
  
)

export default component.exports